module.exports = __webpack_public_path__ + "mobile2.3dd883c3.png";